import React from 'react';
import { Collapse } from '@material-ui/core';
import ButtonLink from './ButtonLink';
import styled from 'styled-components/macro';

const ShowMoreLink = styled(ButtonLink)`
  && {
    text-transform: none;
    color: #4c84ff;
    font-size: 12px;
    padding: 0;
  }
`;
/**
 * Wraps content in a Material UI Collapse with a "Read more" button to toggle it. The prop `peek` sets the height of the content before clicking the button, defaults to 70px.
 *
 * The Collapse is only used when explicitly given the `needsMore` prop. Use a heuristic like the length of some string to set this prop.
 *
 * Example:
 *
 * ```
 * const description = 'Some _markdown_.';
 *
 * <ReadMore needsMore={description.length > 500}>
 *   <Markdown content={description} />
 * </ReadMore>
 * ```
 *
 * @param {object} props
 */

const ReadMore = ({ peek = 100, needsMore = false, children } = {}) => {
  const [open, setOpen] = React.useState(false);

  if (!needsMore) {
    return children;
  }

  return (
    <>
      <Collapse in={open} collapsedHeight={peek}>
        {children}
      </Collapse>
      <ShowMoreLink onClick={() => setOpen(!open)} to="#">
        {open ? 'Show less' : 'Read more'}
      </ShowMoreLink>
    </>
  );
};
export default ReadMore;
